import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { CardiacQuestionnaireItem } from './questionnaire'

export const CARDIAC_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [CardiacQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_WNL]:
    QuestionnaireAnswerType.STRING,
  [CardiacQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_FACTORS]:
    QuestionnaireAnswerType.STRING,
  [CardiacQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_HEART_SOUNDS]:
    QuestionnaireAnswerType.STRING,
  [CardiacQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING
}
